import styled from 'styled-components';
import tw from 'twin.macro';

export const getFieldContainerClass = (isHidden: boolean) => {
  return isHidden ? 'w-full mb-4 none' : 'w-full mb-4 block';
};

export const FileUploaderContainer = styled.div`
  ${tw`flex flex-col justify-center items-center font-inter min-h-[60px] mt-[10px] rounded-[16px]`}
`;

export const FileUploaderSection = styled.section`
  ${tw`flex p-[20px] flex-col justify-center items-center w-full border-dashed rounded-[16px]`};
  ${(props) =>
    props.isNotValid
      ? tw`border-[2px] border-lipstick`
      : tw`border-[1px] border-lightBlueGray300`};
  overflow-wrap: anywhere;
`;

export const StyledLabel = styled.label`
  ${tw`font-inter mb-1 text-sm leading-5 font-normal font-medium text-blue-gray-700`}
`;
export const ErrorMessage = styled.span`
  ${tw`text-xs text-lipstick`}
`;
